import React from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Control, Controller, UseFormSetValue, useWatch } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { StyledAnswerRow } from '../../styles';
import FieldsEditor from './FieldsEditor';
import { StyledToggleBlock } from './styles';

interface Props {
  control: Control<EditableQuestion>;
  setValue: UseFormSetValue<EditableQuestion>;
  index: number;
  onRemove: () => void;
}

/**
 * One unit the patient can choose between: what the segment is called, how its answer
 * reads back, and the fields it shows once selected.
 */
const ToggleBlock = ({ control, setValue, index, onRemove }: Props) => {
  const path = `input.toggles.${index}` as const;

  // Named for the author's own label so the remove control says which toggle it drops.
  const label: string | undefined = useWatch({ control, name: `${path}.label` as 'input.toggles.0.label' });

  return (
    <StyledToggleBlock>
      <StyledAnswerRow>
        <Controller
          name={`${path}.label` as 'input.toggles.0.label'}
          control={control}
          render={({ field: { onChange, ref, ...restField } }) => (
            <TextField
              inputRef={ref}
              {...restField}
              fullWidth
              placeholder="Toggle label"
              onChange={event => onChange(event.target.value)}
            />
          )}
        />
        <Controller
          name={`${path}.answer_template` as 'input.toggles.0.answer_template'}
          control={control}
          render={({ field: { onChange, ref, value, ...restField } }) => (
            <TextField
              inputRef={ref}
              {...restField}
              value={value ?? ''}
              fullWidth
              placeholder="Answer template"
              helperText="Names field ids, e.g. {st}st {lbs}lb. Leave empty to join each field with its suffix."
              onChange={event => onChange(event.target.value)}
            />
          )}
        />
        <IconButton aria-label={`Remove ${label || 'toggle'}`} onClick={onRemove}>
          <Close />
        </IconButton>
      </StyledAnswerRow>
      <FieldsEditor control={control} setValue={setValue} toggleIndex={index} />
    </StyledToggleBlock>
  );
};

export default ToggleBlock;
